import ClinicsDropdown from "lib/components/common/dashboard/clinics-dropdown";
import SimpleCard from "lib/components/common/simple-card";
import SimpleDataTable from "lib/components/common/simple-data-table";
import DashboardLayout from "lib/components/layouts/dashboard";
import { ALL_CLINIC_OPTION } from "lib/constants";
import { PAGE_ROUTES } from "lib/constants/page-routes";
import { SUBSCRIPTIONS_COLUMNS } from "lib/constants/table-columns";
import useClinics from "lib/hooks/useClinics";
import useSubscriptions from "lib/hooks/useSubscription";
import { getItemsFromArray } from "lib/utils/array-utils";
import { useEffect, useState } from "react";
const breadcrumbItems = [
  {
    label: "Dashboard",
    path: PAGE_ROUTES.ADMIN.Dashboard,
  },
  {
    label: "Subscriptions",
    path: PAGE_ROUTES.ADMIN.DashboardSubscription,
  },
] as BreadcrumbItem[];
const DashboardSubscriptionPage = () => {
  const {
    subscriptions,
    getSubscriptions,
    error,
    loading: subscriptionLoading,
  } = useSubscriptions();
  //const [subscriptions, setSubscriptions] = useState<SubscriptionDetails[]>([]);
  const [selectedClinic, setSelectedClinic] = useState<Clinic | null>(
    ALL_CLINIC_OPTION
  );
  const { clinics, getClinics, loading: clinicsLoading } = useClinics();

  useEffect(() => {
    getClinics(false, () => getSubscriptions());
  }, []);

  const filteredSubscriptions =
    selectedClinic?.id === ALL_CLINIC_OPTION.id
      ? subscriptions
      : getItemsFromArray(subscriptions, "clinicId", selectedClinic?.id);

  return (
    <DashboardLayout breadcrumbItems={breadcrumbItems}>
      <SimpleCard
        title="Subscriptions"
        isLoading={subscriptionLoading || clinicsLoading}
        action={
          <ClinicsDropdown
            className="w-25"
            isShowAll={true}
            clinics={clinics ?? []}
            onSelect={setSelectedClinic}
            selectedClinic={selectedClinic}
          />
        }
      >
        <SimpleDataTable
          columns={SUBSCRIPTIONS_COLUMNS}
          data={filteredSubscriptions ?? []}
        />
      </SimpleCard>
    </DashboardLayout>
  );
};

export default DashboardSubscriptionPage;
